import { useCallback, useEffect, useState } from "react"

export function buildAuthHeaders(includeJson = false) {
  const token = localStorage.getItem("odontoflow_token") || ""
  const clinicId = localStorage.getItem("odontoflow_clinic_id") || ""

  const headers = {}

  if (includeJson) {
    headers["Content-Type"] = "application/json"
  }

  if (token) {
    headers["Authorization"] = `Bearer ${token}`
  }

  if (clinicId && clinicId !== "ALL") {
    headers["x-clinic-id"] = clinicId
  }

  return headers
}

const EMPTY_DAILY_OPPORTUNITIES = {
  total: 0,
  high: 0,
  medium: 0,
  low: 0,
  rows: []
}

export default function useDailyOpportunities({ clinicId, date }) {
  const [dailyOpportunities, setDailyOpportunities] = useState(
    EMPTY_DAILY_OPPORTUNITIES
  )
  const [loadingDailyOpportunities, setLoadingDailyOpportunities] = useState(false)

  const loadDailyOpportunities = useCallback(async () => {
    setDailyOpportunities(EMPTY_DAILY_OPPORTUNITIES)
    setLoadingDailyOpportunities(false)
    return EMPTY_DAILY_OPPORTUNITIES
  }, [])

  useEffect(() => {
    loadDailyOpportunities()
  }, [clinicId, date, loadDailyOpportunities])

  return {
    dailyOpportunities,
    loadingDailyOpportunities,
    loadDailyOpportunities
  }
}
